module.exports = __webpack_public_path__ + "img/blog-post-cover.c2bc1473.png";